// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609032317/js/" + chunkId + "." + {"44":"dfeb7ce7","225":"10a36178","481":"805831fe","486":"382baff7","770":"00d05bc4"}[chunkId] + ".0.18570708315450246.chunk.js";
};